<cm-topbar title="API"></cm-topbar>

<div class="main-content">
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-8 col-lg-6 mx-auto">
        <mat-card>
          <mat-card-header>
            <!--<mat-card-title>-->
            <!--API-->
            <!--</mat-card-title>-->
          </mat-card-header>
          <mat-card-content class="p-3">
            <p>The Consumable reporting API is a JSON-based REST API which allows you to communicate with the Consumable Platform.</p>
            <p>The report service allows you to make a single API request to set the report date range, select report attributes, and generate a report.</p>
            <p>If you have any issues or questions, feel free to write us at <a href="mailto:support@consumable.com">support@consumable.com</a></p>
          </mat-card-content>
        </mat-card>
        <div class="text-center mt-4">
          <a mat-raised-button color="primary" class="large" href="http://publisher-api.consumable.com/docs/" target="_blank">
            <i class="fal fa-external-link" aria-hidden="true"></i>
            <span class="ml-2">Documentation</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
